import React from 'react';

import AutoMargin from './AutoMargin';
import { Form, Formik } from 'formik';
import InputText from './Formik/InputText';
import { RequestPasswordRecoverySchema } from 'utils/validators/passwordRecovery';
import { requestPasswordRecoveryApi } from 'utils/api/passwordRecovery';
import { toast } from 'react-toastify';
import { i18n } from 'utils/i18n/index';

interface RequestPasswordRecoveryProps {
  cancel: () => void;
}

const RequestPasswordRecovery: React.FC<RequestPasswordRecoveryProps> = ({
  cancel,
}) => {
  return (
    <AutoMargin className="lg:w-96 bg-white rounded mt-5 p-8">
      <div className="font-medium text-xl text-black">{i18n.t("recoverPassword")}</div>
      <div className="mb-16">
        {i18n.t("enterYourEmailToRecoverPassword")}
      </div>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={RequestPasswordRecoverySchema}
        onSubmit={(values, actions) => {
          actions.setSubmitting(true);
          const promise = requestPasswordRecoveryApi(values);
          toast.promise(promise, {
            pending: `${i18n.t("sendingPasswordRecoveryEmail")}`,
            success: {
              render() {
                actions.setSubmitting(false);
                cancel();
                return `${i18n.t("emailSent")}`;
              },
            },
            error: {
              render() {
                actions.setSubmitting(false);
                return `${i18n.t("TryAgainLater")}`;
              },
            },
          });
        }}
      >
        {({ isSubmitting }) => (
          <Form className="flex flex-col">
            <label className="flex flex-col text-xs w-full mt-6">
              {i18n.t("email")}
              <InputText name="email" placeholder={i18n.t("typeYourEmail")} />
            </label>
            <button
              disabled={isSubmitting}
              type="submit"
              className="py-2 bg-primary-darker text-white box-border rounded-full mt-10 disabled:opacity-30"
            >
              {i18n.t("recoverPasswordButton")}
            </button>
            <button
              onClick={cancel}
              className="py-2 bg-white border text-primary-darker box-border rounded-full mt-3 text-center"
            >
              {i18n.t("cancel")}
            </button>
          </Form>
        )}
      </Formik>
    </AutoMargin>
  );
};

export default RequestPasswordRecovery;
